import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { AboutEraman } from "./AboutEraman/AboutEraman";
import { Address } from "./Address/Address";
import { Copyrights } from "./Copyrights/Copyrights";
import { EramanLogo } from "./EramanLogo/EramanLogo";
import { EramanPrivilege } from "./EramanPrivilege/EramanPrivilege";
import { SocialMediaIcons } from "./SocialMediaIcons/SocialMediaIcons";
import { TravellersInfo } from "./TravellersInfo/TravellersInfo";

export const Footer = () => {
  const query = useQuery();
  const navigate = useNavigate();

  useEffect(() => {
    if (!query.get("activeTab")) {
      navigate(`/dedicated/eraman/footer?activeTab=socialMediaIcons`, {
        replace: true,
      });
    }
  }, []);

  const items = [
    {
      label: "Social Media Icons",
      key: "socialMediaIcons",
      children: <SocialMediaIcons />,
    },
    {
      label: "Logo",
      key: "eramanLogo",
      children: <EramanLogo />,
    },
    {
      label: "Contact Centre",
      key: "contactCentre",
      children: <Address />,
    },
    {
      label: "Copyrights",
      key: "copyrights",
      children: <Copyrights />,
    },
    // {
    //   label: "Content",
    //   key: "contents",
    //   children: <Contents />,
    // },
    {
      label: "About Eraman",
      key: "aboutEraman",
      children: <AboutEraman />,
    },
    {
      label: "Eraman Privilege Card",
      key: "eramanPrivilege",
      children: <EramanPrivilege />,
    },
    {
      label: "Traveller's Info",
      key: "travellersInfo",
      children: <TravellersInfo />,
    },
  ];

  return (
    <ContentWrapper title={"Footer"}>
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
